import script from "./NotebookPagesEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./NotebookPagesEditor.vue?vue&type=script&setup=true&lang=js"

import "./NotebookPagesEditor.vue?vue&type=style&index=0&id=382b5772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-382b5772"]])

export default __exports__